import { getMarketplaceCountry } from '../api/utils';

/** A visibility rule that always returns true (card is always shown). */
export const ALWAYS_VISIBLE: () => boolean = () => {
  return true;
};

/**
 * Returns a visibility rule that hides content for the specified countries.
 * When `countryCodes` is empty or undefined, the rule returns `true` (visible everywhere).
 *
 * @param countryCodes - Comma-separated country codes (e.g. "US,GB")
 * @returns A thunk `() => boolean` — `true` if visible, `false` if hidden
 */
export const visibleExceptForCountries =
  (countryCodes = ''): (() => boolean) =>
  () => {
    const codes = countryCodes ?? '';
    const marketplaceCountry = getMarketplaceCountry().toUpperCase();
    return (
      !marketplaceCountry.length ||
      !codes
        .toUpperCase()
        .split(',')
        .some((code) => code.trim() === marketplaceCountry)
    );
  };

/**
 * Combines multiple visibility rules with AND logic.
 * The resulting rule returns `true` only if all individual rules return `true`.
 *
 * @param rules - Visibility rule functions to combine
 * @returns A thunk `() => boolean` that evaluates all rules
 */
export const combineRules =
  (...rules: Array<() => boolean>): (() => boolean) =>
  () =>
    rules.every((rule) => rule());
